"use strict";

var _require = require("./style.js"),
  forEachStyleDeclaration = _require.forEachStyleDeclaration;
var color = require("./color-parser.js");
var _require2 = require("./regex.js"),
  numberRegex = _require2.numberRegex,
  percentRegex = _require2.percentRegex;
var _require3 = require("./size-converter.js"),
  toDXA = _require3.toDXA,
  toPoint = _require3.toPoint;
var _require4 = require("./attributes.js"),
  getSingleAttribute = _require4.getSingleAttribute,
  getSingleNumAttribute = _require4.getSingleNumAttribute;
var _require5 = require("lodash"),
  get = _require5.get;
function addRunStyle(_ref) {
  var element = _ref.element,
    props = _ref.props,
    transformer = _ref.transformer;
  var name = element.name;
  var getXmlProperties = transformer.tagRepository.getXmlProperties;
  if (name) {
    var xmlProperties = getXmlProperties(name);
    if (xmlProperties != null) {
      props = props.concat([xmlProperties]);
    }
  }
  // eslint-disable-next-line complexity
  forEachStyleDeclaration(element, transformer, function (_ref2) {
    var property = _ref2.property,
      value = _ref2.value;
    if (property === "white-space" && value === "pre") {
      props.push("preformatted");
    }
    if (property === "-xt-tab-stop" && value === "tabstop") {
      props.push("tabstop");
    }
    if (property === "color") {
      props = props.concat([{
        type: "string",
        tag: "w:color",
        value: "<w:color w:val=\"".concat(color(value), "\"/>")
      }]);
    }
    if (property === "break-after" && value === "page") {
      props.push("break-page-after");
    }
    if (property === "break-before" && value === "page") {
      props.push("break-page-before");
    }
    if (property === "font-style") {
      if (value === "italic") {
        props.push({
          type: "string",
          tag: "w:i",
          value: "<w:i/>"
        });
      }
    }
    if (property === "font-weight") {
      if (value === "bold" || value === "bolder") {
        props.push("bold");
      } else if (numberRegex.test(value)) {
        var number = parseInt(value, 10);
        if (number >= 700) {
          props.push("bold");
        }
      }
    }
    if (property === "font-variant") {
      if (value === "normal") {
        props = props.concat([{
          type: "string",
          tag: "w:smallCaps",
          value: '<w:smallCaps w:val="false"/>'
        }]);
      }
      if (value === "small-caps") {
        props = props.concat([{
          type: "string",
          tag: "w:smallCaps",
          value: "<w:smallCaps/>"
        }]);
      }
    }
    if (property === "font-size") {
      var point = toPoint(value, transformer);
      if (point != null) {
        var fontsize = Math.round(2 * point);
        props = props.concat([{
          type: "string",
          tag: "w:sz",
          value: "<w:sz w:val=\"".concat(fontsize, "\"/>")
        }, {
          type: "string",
          tag: "w:szCs",
          value: "<w:szCs w:val=\"".concat(fontsize, "\"/>")
        }]);
      }
    }
    if (property === "font-family") {
      value = value.split(",")[0].trim().replace(/^['"]/, "").replace(/['"]$/, "");
      if (value === "initial" || value === "inherit") {
        return;
      }
      if (value === "monospace") {
        value = "DejaVu Sans Mono";
      }
      if (value === "cursive") {
        value = "Brush Script";
      }
      if (value === "monospace") {
        value = "DejaVu Sans Mono";
      }
      if (value === "fantasy") {
        value = "DejaVu Sans Mono";
      }
      if (value === "serif") {
        value = "DejaVu Serif";
      }
      if (value === "sans-serif") {
        value = "DejaVu Sans";
      }
      props = props.concat([{
        type: "string",
        tag: "w:rFonts",
        value: "<w:rFonts w:ascii=\"".concat(value, "\" w:hAnsi=\"").concat(value, "\"/>")
      }]);
    }
    if (property === "background-color") {
      var col = color(value);
      if (col) {
        props = props.concat([{
          type: "string",
          value: "<w:shd w:val=\"clear\" w:color=\"auto\" w:fill=\"".concat(color(value), "\"/>")
        }]);
      }
    }
    if (property === "text-decoration" && value === "underline") {
      props = props.concat("underline");
    }
  });
  return props;
}
function removeElementFromArray(array, element) {
  var index = array.indexOf(element);
  if (index === -1) {
    return;
  }
  array.splice(index, 1);
}

// eslint-disable-next-line complexity
function addParagraphStyle(x) {
  var element = x.element,
    transformer = x.transformer,
    customProperties = x.customProperties;
  var align, before, after, lineHeight, myFontSize;
  (transformer.otherRunProperties || []).forEach(function (_ref3) {
    var tag = _ref3.tag,
      value = _ref3.value;
    if (tag === "w:sz") {
      myFontSize = getSingleNumAttribute(value, "w:val") / 2 + "pt";
    }
  });
  var paragraphTypes = element.paragraphTypes;
  if (element.name === "p" && transformer.styleDefaults.paragraph) {
    var containsStyle = paragraphTypes.some(function (paragraphType) {
      return paragraphType.indexOf("<w:pStyle ") === 0;
    });
    if (!containsStyle) {
      paragraphTypes.push("<w:pStyle w:val=\"".concat(transformer.styleDefaults.paragraph, "\"/>"));
    }
  }
  var leftIndent = 0;
  var textIndent = 0;
  if (element.name === "blockquote") {
    paragraphTypes.push('<w:ind w:left="721"/>');
  }

  /* eslint-disable-next-line complexity */
  forEachStyleDeclaration(element, transformer, function (_ref4) {
    var property = _ref4.property,
      value = _ref4.value;
    if (property === "break-after") {
      if (value === "avoid") {
        paragraphTypes.push("<w:keepNext/>");
      }
      if (["auto", "unset", "initial"].indexOf(value) !== -1) {
        removeElementFromArray(paragraphTypes, "<w:keepNext/>");
      }
    }
    if (property === "background-color") {
      var col = color(value);
      if (col) {
        paragraphTypes.push("<w:shd w:val=\"clear\" w:color=\"auto\" w:fill=\"".concat(color(value), "\"/>"));
      }
    }
    if (property === "text-align") {
      if (["center", "left", "right"].indexOf(value) !== -1) {
        align = value;
      }
      if (value === "justify") {
        align = "both";
      }
    }
    if (property === "padding-left") {
      var dxa = toDXA(value, transformer);
      if (dxa != null) {
        leftIndent += dxa;
      }
    }
    if (property === "margin-left") {
      var _dxa = toDXA(value, transformer);
      if (_dxa != null) {
        leftIndent += _dxa;
      }
    }
    if (property === "text-indent") {
      var _dxa2 = toDXA(value, transformer);
      if (_dxa2 != null) {
        textIndent += _dxa2;
      }
    }
    if (property === "margin-top") {
      var _dxa3 = toDXA(value, transformer);
      if (_dxa3 != null) {
        before = _dxa3;
      }
    }
    if (property === "margin-bottom") {
      var _dxa4 = toDXA(value, transformer);
      if (_dxa4 != null) {
        after = _dxa4;
      }
    }
    if (property === "font-size") {
      myFontSize = value;
    }

    // this property is always parsed after fontsize,, thus we can calculate the relative value.
    if (property === "line-height") {
      if (percentRegex.test(value)) {
        var fontDxa = toDXA(myFontSize, transformer);
        lineHeight = parseFloat(value, 10) / 100 * fontDxa;
      } else if (numberRegex.test(value)) {
        var _fontDxa = toDXA(myFontSize, transformer);
        lineHeight = parseFloat(value, 10) * _fontDxa;
      } else {
        var _dxa5 = toDXA(value, transformer);
        if (_dxa5 != null) {
          lineHeight = _dxa5;
        }
      }
      if (lineHeight === 0) {
        throw new Error("lineHeight === 0");
      }
    }
  });
  if (before != null || after != null || lineHeight != null) {
    (customProperties || []).forEach(function (_ref5) {
      var tag = _ref5.tag,
        value = _ref5.value;
      if (["w:spacing"].indexOf(tag) !== -1) {
        before = before == null ? getSingleAttribute(value, "w:before") : before;
        after = after == null ? getSingleAttribute(value, "w:after") : after;
      }
    });
    element.paragraphTypes.push("<w:spacing ".concat([before != null ? "w:before=\"".concat(before, "\"") : "", after != null ? "w:after=\"".concat(after, "\"") : "", lineHeight != null ? "w:line=\"".concat(lineHeight, "\"") : "", lineHeight != null ? 'w:lineRule="exact"' : ""].filter(function (f) {
      return f;
    }).join(" "), "/>"));
  }
  align || (align = get(element, "attribs.align"));
  if (align === "justify") {
    align = "both";
  }
  if (["center", "left", "right", "both"].indexOf(align) !== -1) {
    paragraphTypes.push("<w:jc w:val=\"".concat(align, "\"/>"));
  }
  if (leftIndent || textIndent) {
    paragraphTypes.push("<w:ind w:left=\"".concat(leftIndent, "\" w:right=\"0\" w:hanging=\"").concat(-textIndent, "\"/>"));
  }
  return paragraphTypes;
}
module.exports = {
  addRunStyle: addRunStyle,
  addParagraphStyle: addParagraphStyle
};